import SearchIcon from "@mui/icons-material/Search";

function OrdersSearch({ value, onChange, isStuck, searchShellRef }) {
  return (
    <div
      ref={searchShellRef}
      className={`search-shell${isStuck ? " is-stuck" : ""}`}
    >
      <label className="search-field">
        <SearchIcon />
        <input
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder="Search for an order..."
        />
      </label>
    </div>
  );
}

export default OrdersSearch;
